module.exports = __webpack_public_path__ + "media/right hemicolectomy.f9e024cf.wav";